import React from "react";
import "./Button.css";
import PropTypes from "prop-types";
const Button = ({ onClick, text, style, className, disable = false }) => {
  return (
    <div class="text-center">
      <button className={`buttontext ${className}`} onClick={onClick} style={style} disabled={disable}>
        {text}
      </button>
    </div>
  );
};
Button.protypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
};
export default Button;
